import React, { useEffect, useRef, useCallback } from 'react';
import { MessageDialog, Size } from '@lux/dialog';
import { AccountSecurity, GraphicSize } from '@lux/graphics';
import { useTranslate } from '@pegasus/translation';
import { TRANSITION, LOGIN } from './constants';
import { getSSOUrl } from './service';
import { AlignTextCenter } from './styled';
import { isMobileScreenSize, track, TrackEvent } from './helpers';
const content = {
    [TRANSITION]: {
        headline: 'transitioned_headline',
        message: 'transitioned_description',
        login: 'go_to_login',
    },
    [LOGIN]: {
        headline: 'welcome_back_fs_headline',
        message: 'welcome_back_fs_description',
        login: 'go_to_login',
    },
};
const getContentBasedOnView = (view) => content[view];
export const TransitionOrExistingUser = ({ showModal, handleOnClose, localeCode, passwordResetEmail, redirectPathOnClose, closable, view, }) => {
    const emailFieldElm = useRef(null);
    const translate = useTranslate();
    useEffect(() => {
        if (view === LOGIN) {
            track(TrackEvent.TRACK_DATA, {
                generatedUrl: 'fb/deprecation/zalandoLogin',
            });
        }
    }, [view]);
    const handleLoginButtonClick = useCallback(() => {
        const handleSSORedirect = async () => {
            const ssoUrl = await getSSOUrl(localeCode, {
                passwordResetEmail,
                redirectionPath: redirectPathOnClose,
            });
            window.location.href = ssoUrl;
        };
        handleSSORedirect();
    }, [getSSOUrl, passwordResetEmail, view]);
    useEffect(() => {
        if (emailFieldElm && emailFieldElm.current) {
            emailFieldElm.current.focus();
        }
    }, []);
    const viewSpecificContent = getContentBasedOnView(view);
    return (React.createElement(MessageDialog, { isShown: showModal, graphic: React.createElement(AccountSecurity, { size: GraphicSize.XXL }), size: isMobileScreenSize() ? Size.M : Size.S, closeDialog: handleOnClose, closeLabel: translate('close_tooltip'), closeIcon: closable, title: translate(viewSpecificContent.headline), text: React.createElement(AlignTextCenter, null, translate(viewSpecificContent.message)), positiveButtonText: translate(viewSpecificContent.login), positiveButtonProps: {
            onClick: handleLoginButtonClick,
        } }));
};
//# sourceMappingURL=transitionOrExistingUser.js.map